import { useEffect } from 'react';

function scrollActiveBlockIntoView(blockId: string): boolean {
  const el = document.querySelector(`[data-block-id="${CSS.escape(blockId)}"]`);
  if (!el) {
    return false;
  }
  /* Fixed float chrome is already on-screen — scrolling it yanks the canvas. */
  if (el.classList.contains('ws-float-chrome')) {
    return true;
  }
  el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  return true;
}

/** Scroll the preview canvas when the shell selects a block from the site tree. */
export function useScrollToActiveBlock(
  activeBlockId: string | null,
  activePageId: string | null,
  canvasRevision: string,
): void {
  useEffect(() => {
    if (!activeBlockId) {
      return;
    }

    let cancelled = false;
    let retryTimer: number | null = null;

    const attemptScroll = () => {
      if (cancelled) {
        return;
      }
      if (scrollActiveBlockIntoView(activeBlockId)) {
        return;
      }
      retryTimer = window.setTimeout(() => {
        scrollActiveBlockIntoView(activeBlockId);
      }, 50);
    };

    if (scrollActiveBlockIntoView(activeBlockId)) {
      return () => {
        cancelled = true;
      };
    }

    const frame = window.requestAnimationFrame(attemptScroll);

    return () => {
      cancelled = true;
      window.cancelAnimationFrame(frame);
      if (retryTimer !== null) {
        window.clearTimeout(retryTimer);
      }
    };
  }, [activeBlockId, activePageId, canvasRevision]);
}
